// extracted by mini-css-extract-plugin
export var displayNone = "_mu-6";
export var imgContainer = "_mu-2";
export var overflowHidden = "_mu-3";
export var productInfoCardButtonContainer = "_mu-5";
export var productTitleText = "_mu-4";
export var rightArrow = "_mu-1";
export var rightArrowContainer = "_mu-0";